module.exports = __webpack_public_path__ + "static/screen02-ff6708aac6eca2d8bb3d4db1c7756a78.jpg";